<template>
  <div class="printAgenda">
    <h1>Agenda for {{ user.firstname }} {{ user.lastname }}</h1>

    <section>
      <div class="conference-title" v-t="'message.AgendaCard.all_conferences'"></div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col" v-t="'message.AgendaCard.conference'"></th>
            <th scope="col" v-t="'message.AgendaCard.student'"></th>
            <th scope="col" v-t="'message.AgendaCard.meeting_with'"></th>
            <th scope="col" v-t="'message.AgendaCard.date_time'"></th>
            <th scope="col" v-t="'message.AgendaCard.location'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="appointment in getAgenda()" :key="appointment.pta_id">
            <td data-col="Conference: ">{{ appointment.conference_name }}</td>
            <td data-col="Child: ">{{ appointment.child_name }}</td>
            <td data-col="Meeting: ">{{ appointment.name }}</td>
            <td class="text-nowrap commaBlock" data-col="Date/Time: ">
              {{ dayjs(appointment.timeslot).locale($i18n.locale).format("MMM Do, h:mm A") }}
            </td>
            <td data-col="Meeting Type/Location: ">
              <span
                class="d-flex align-items-center"
                v-if="
                  (!appointment.virtual_room && appointment.room) ||
                  appointment.meeting_type == 'in_person'
                "
              >
                {{
                  (appointment.room != null && appointment.room !== '') ?
                    $t("message.AgendaCard.room_with_value", { room: appointment.room }) :
                    $t("message.AgendaCard.room")
                }}
              </span>
              <span
                class="d-flex align-items-center"
                v-t="'message.AgendaCard.virtual_meeting'"
                v-if="
                  (!appointment.room && appointment.virtual_room) ||
                  appointment.meeting_type == 'virtual'
                "
              >
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section v-for="conference in conferences" :key="conference.conference_id">
      <div class="conference-title">{{ conference.conference_name }}</div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col" v-t="'message.AgendaCard.student'"></th>
            <th scope="col" v-t="'message.AgendaCard.meeting_with'"></th>
            <th scope="col" v-t="'message.AgendaCard.date_time'"></th>
            <th scope="col" v-t="'message.AgendaCard.location'"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="appointment in getAgendaByConference(conference.conference_id)"
            :key="appointment.pta_id"
          >
            <td data-col="Child: ">{{ appointment.child_name }}</td>
            <td data-col="Meeting: ">{{ appointment.name }}</td>
            <td class="text-nowrap commaBlock" data-col="Date/Time: ">
              {{ dayjs(appointment.timeslot).locale($i18n.locale).format("MMM Do, h:mm A") }}
            </td>
            <td data-col="Meeting Type/Location: ">
              <span
                class="d-flex align-items-center"
                v-if="
                  (!appointment.virtual_room && appointment.room) ||
                  appointment.meeting_type == 'in_person'
                "
              >
                {{
                  (appointment.room != null && appointment.room !== '') ?
                    $t("message.AgendaCard.room_with_value", { room: appointment.room }) :
                    $t("message.AgendaCard.room")
                }}
              </span>
              <span
                class="d-flex align-items-center"
                v-t="'message.AgendaCard.virtual_meeting'"
                v-if="
                  (!appointment.room && appointment.virtual_room) ||
                  appointment.meeting_type == 'virtual'
                "
              >
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <footer>
      <!-- <p>Generated at 12:00 AM on Tue, Jan 01, 2022 by PTC Wizard</p> -->
      <p>Generated at {{ dayjs().format("h:mm A on ddd, MMM Do, YYYY") }} by PTC Wizard</p>
      <figure class="logo" alt="PTC Wizard Logo">
        <Logo />
      </figure>
    </footer>
  </div>
</template>
<script setup>
import dayjs from "dayjs";
import advancedFormat from "dayjs/esm/plugin/advancedFormat";

// import { useAgendaStore } from '@/stores/agenda';
import Logo from "@/assets/icons/logo-vertical-regular.svg";

// const agendaStore = useAgendaStore();
const props = defineProps({
  conferences: Array,
  school: Array,
  agenda: Array,
  user: Object
});

dayjs.extend(advancedFormat);
function getAgendaByConference(conferenceId) {
  return props.agenda
    .filter((meeting) => meeting.conference_id == conferenceId)
    .sort((a, b) => {
      return a.start < b.start ? -1 : 1;
    });
}
function getAgenda() {
  if (props.conference !== undefined) {
    return props.agenda
      .filter((meeting) => meeting.conference_id == props.conference.conference_id)
      .sort((a, b) => {
        return a.start < b.start ? -1 : 1;
      });
  } else {
    // console.log(props.agenda);
    return props.agenda;
  }
}
</script>
